<template>
  <div class="f-mainHeader">
    <b-navbar class=" bg-transparent" sticky toggleable="md" variant="primary">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand active append class="home-brand" exact replace>
        <a href="http://www.alpine-space.eu/projects/alpfoodway/en/home" target="_blank"><img
          class="alp-logo" src="../../assets/alpfoodway_logo.png"/></a>
      </b-navbar-brand>

      <b-collapse id="nav_collapse" is-nav>
        <b-navbar-nav class="ml-auto f-navbar highlight" fill justified>
          <b-nav-item v-bind:class="{ active: isHomeActive}" v-on:click="loadHome">
            {{activeLanguage.home}}
          </b-nav-item>
          <b-nav-item v-on:click="loadInventory">
            {{activeLanguage.inventory}}
          </b-nav-item>
          <b-nav-item v-bind:class="{ active: isGalleryActive}" v-on:click="loadGallery">
            {{activeLanguage.gallery}}
          </b-nav-item>
          <b-nav-item v-bind:class="{ active: isEventsActive}" v-on:click="loadEvents">
            {{activeLanguage.events}}
          </b-nav-item>
          <b-nav-item v-bind:class="{ active: isSocialWallActive}" v-on:click="loadSocialWall">
            {{activeLanguage.socialWall}}
          </b-nav-item>
          <!--          <b-nav-item v-bind:class="{ active: isContestActive}" v-on:click="loadContest">-->
          <!--            {{activeLanguage.contest}}-->
          <!--          </b-nav-item>-->
          <b-nav-item v-bind:class="{ active: isVideosActive}" v-on:click="loadVideos">
            {{activeLanguage.youtubeGallery}}
          </b-nav-item>
          <b-nav-item v-bind:class="{ active: isNewsActive}" v-on:click="loadNews">
            {{activeLanguage.news}}
          </b-nav-item>
          <b-nav-item v-bind:class="{ active: isSupportersActive}" v-on:click="loadSupporters">
            {{activeLanguage.supporters}}
          </b-nav-item>
          <b-nav-item v-bind:class="{ active: isPaperActive}" v-on:click="loadPaper">
            {{activeLanguage.theCarta}}
          </b-nav-item>

          <!--          <b-nav-item v-bind:class="{ active: isInventoryMapActive}" v-on:click="loadInventoryMap">-->
          <!--            {{activeLanguage.inventoryMap}}-->
          <!--          </b-nav-item>-->
          <b-nav-item id="bordered-petition"
                      v-bind:class="{ active: isSignPetitionActive}"
                      v-on:click="loadSignPetition">
            {{activeLanguage.signPetition}}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
    import HomePage from '../pagesComponents/homePageComponents/HomePage'
    import EventsPage from '../pagesComponents/eventsPageComponents/EventsPage'
    import SocialWallPage from '../pagesComponents/socialsPageComponents/SocialWallPage'
    import NewsPage from '../pagesComponents/newsPageComponents/NewsPage'
    import SupportersPage from '../pagesComponents/supportersPageComponents/SupportersPage'
    import SignPetitionPage from '../pagesComponents/signPetitionPageComponents/SignPetitionPage'
    import PaperPage from '../pagesComponents/paperPageComponents/PaperPage'
    import ContestPage from '../pagesComponents/contestPageComponents/ContestPage'
    import VideosPage from '../pagesComponents/videosPageComponents/VideosPage'
    import InventoryMapPage from '../pagesComponents/inventoryMapPageComponents/InventoryMapPage'
    // import GalleryPage from '../pagesComponents/galleryPageComponents/GalleryPage'

export default {
      name: 'MainHeader',
      computed: {
        isHomeActive () {
          return this.$store.getters.currentViewValue.name === 'HomePage'
        },
        isEventsActive () {
          return this.$store.getters.currentViewValue.name === 'EventsPage'
        },
        isSocialWallActive () {
          return this.$store.getters.currentViewValue.name === 'SocialWallPage'
        },
        isContestActive () {
          return this.$store.getters.currentViewValue.name === 'ContestPage'
        },
        isNewsActive () {
          return this.$store.getters.currentViewValue.name === 'NewsPage'
        },
        isSupportersActive () {
          return this.$store.getters.currentViewValue.name === 'SupportersPage'
        },
        isSignPetitionActive () {
          return this.$store.getters.currentViewValue.name === 'SignPetitionPage'
        },
        isPaperActive () {
          return this.$store.getters.currentViewValue.name === 'PaperPage'
        },
        isVideosActive () {
          return this.$store.getters.currentViewValue.name === 'VideosPage'
        },
        isInventoryMapActive () {
          return this.$store.getters.currentViewValue.name === 'InventoryMapPage'
        },
        isGalleryActive () {
          return this.$store.getters.currentViewValue.name === 'GalleryPage'
        },
        activeLanguage () {
          return this.$translations[this.$store.getters.currentLanguageValue]
        }
      },
      methods: {
        loadHome () {
          this.$store.commit('setCurrentView', HomePage)
          this.$router.push('/home' + this.getCurrentLanguage())
        },
        loadEvents () {
          this.$store.commit('setCurrentView', EventsPage)
          this.$router.push('/events' + this.getCurrentLanguage())
        },
        loadSocialWall () {
          this.$store.commit('setCurrentView', SocialWallPage)
          this.$router.push('/social-wall' + this.getCurrentLanguage())
        },
        loadContest () {
          this.$store.commit('setCurrentView', ContestPage)
          this.$router.push('/contest' + this.getCurrentLanguage())
        },
        loadNews () {
          this.$store.commit('setCurrentView', NewsPage)
          this.$router.push('/news' + this.getCurrentLanguage())
        },
        loadSupporters () {
          this.$store.commit('setCurrentView', SupportersPage)
          this.$router.push('/supporters' + this.getCurrentLanguage())
        },
        loadSignPetition () {
          this.$store.commit('setCurrentView', SignPetitionPage)
          this.$router.push('/sign-petition' + this.getCurrentLanguage())
        },
        loadPaper () {
          this.$store.commit('setCurrentView', PaperPage)
          this.$router.push('/paper' + this.getCurrentLanguage())
        },
        loadVideos () {
          this.$store.commit('setCurrentView', VideosPage)
          this.$router.push('/videos-gallery' + this.getCurrentLanguage())
        },
        loadInventoryMap () {
          this.$store.commit('setCurrentView', InventoryMapPage)
          this.$router.push('/inventory-map' + this.getCurrentLanguage())
        },
        loadGallery () {
          // this.$store.commit('setCurrentView', GalleryPage)
          // this.$router.push('/gallery' + this.getCurrentLanguage())
          window.open('http://intangiblesearch.eu/alpfoodway-webdoc', '_blank')
        },
        loadInventory () {
          let language
          switch (this.$store.getters.currentLanguageValue) {
            case 'Italian':
              language = this.$translations['Italian'].italianLanguage
              break
            case 'English':
              language = this.$translations['Italian'].englishLanguage
              break
            case 'German':
              language = this.$translations['Italian'].germanLanguage
              break
            case 'French':
              language = this.$translations['Italian'].frenchLanguage
              break
            case 'Slovenian':
              language = this.$translations['Italian'].englishLanguage
              break
            default:
              break
          }
          window.open('http://intangiblesearch.eu/search/search_by_tag.php?db_name=intangible_search&lingua=' + language.toLowerCase() + '&tag_code=TAG_1268&showmode=MAP\n', '_blank')
        },
        getCurrentLanguage () {
          switch (this.$store.getters.currentLanguageValue) {
            case 'Italian':
              return '/italian'
            case 'English':
              return '/english'
            case 'German':
              return '/german'
            case 'French':
              return '/french'
            case 'Slovenian':
              return '/slovenian'
            default:
              return '/italian'
          }
        }
      }
    }
</script>

<style scoped>

  .f-mainHeader {
    padding-top: 1px;
    padding-bottom: 1px;
    background-color: rgb(251, 251, 251);
    border-bottom: 1px solid #dee2e6;
    z-index: 10;
    width: 100%;
  }

  .shrink-border {
    height: 85px;
    /*margin-top: 0;*/
    margin-left: 5%;
    margin-right: 5%;
    /*margin-left: 15%;*/
    /*margin-right: 15%;*/
  }

  .f-navbar {
    border-bottom: 0 !important;
  }

  #bordered-petition:hover {
    margin-bottom: 0 !important;
    border-bottom: 0 !important;
  }

  #bordered-petition > a {
    border: 1px solid black;
    border-radius: 0 !important;
    background-color: #c41c21 !important;
    color: white !important;
    text-decoration: none;
    margin-bottom: 0 !important;
    border-bottom: 1px solid black !important;
  }

  #bordered-petition > a:hover {
    border: 1px solid black;
    /*color: transparent;*/
    background-color: #c41c21 !important;
    color: white !important;
    text-decoration: none;
    font-weight: bold;
    margin-bottom: 0 !important;
    border-bottom: 1px solid black !important;
  }

  #bordered-petition > a:focus {
    border: 1px solid black;
    border-radius: 0;
    /*color: transparent;*/
    text-decoration: none;
    background-color: white !important;
    color: #c41c21 !important;
  }

  .highlight > li:hover,
  .highlight > li:focus {
    background-color: transparent;
    border-color: transparent;
    border-bottom: 2px solid #c41c21;
    border-radius: 0;
  }

  .highlight > li > a:hover,
  .highlight > li > a:focus {
    background-color: transparent;
    border-color: transparent;
    border-radius: 0;
    color: #c41c21;
  }

  .f-navbar > li > a {
    color: black;
  }

  .f-navbar > li {
    margin-left: 5px;
    margin-right: 5px;
    white-space: nowrap;
  }

  .b-nav-dropdown > a {
    border: none;
  }

  .alp-logo {
    width: 150px;
  }

  .is-logo {
    width: 200px;
  }

  .active > a {
    color: #c41c21 !important;
    font-weight: bold
  }

  .active > a:hover {
    border-bottom: 0;
  }

  .active > a:focus {
    border-bottom: 0;
  }

  .home-brand {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/headerComponents/MainHeader.vue